import { PageHeading } from '@/console/ui/PageHeading'
import { TABS } from '@/console/shell/tabs'
import { McisCutoverRollbackResendPanel } from './McisCutoverRollbackResendPanel'

const tab = TABS.find((t) => t.key === 'erp')!

/**
 * ERP 복구 탭(LOGISPRD-14487) — MCIS→SAP 출고실적 컷오버를 되돌릴 때 SAP 재송신 대기 원장(OIF_LO_GI)을 복원한다.
 * 입고·MASS·F-OPT 어느 도메인에도 속하지 않는 고위험 조치라 탭을 따로 둔다.
 */
export const ErpTab = ({ onBusyChange }: { onBusyChange?: (busy: boolean) => void }): JSX.Element => (
  <>
    <PageHeading title={tab.heading} sub={tab.sub} />
    <McisCutoverRollbackResendPanel onBusyChange={onBusyChange} />
  </>
)
